import type { AppState } from '@store/types'

export const selectApiKeys = (state: AppState) => state.apiKeys.list

export const selectApiKeysError = (state: AppState) => state.apiKeys.error
